"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getResults = getResults;
exports.questions = void 0;

var _utils = require("./utils");

var batteryId = _utils.screeners.workplaceQuestionnaire5;
var agreeDisagree = ["Strongly disagree", "Disagree", "Slightly disagree", "Neither agree nor disagree", "Slightly agree", "Agree", "Strongly agree"];
var baseProps = {
  batteryId: batteryId,
  aggregated: true,
  type: "multi",
  extraText: "",
  options: agreeDisagree
};
var workplaceQuestions = [// Workplace Questionnaire - 5 questions
{
  prompt: "I feel satisfied with my job."
}, {
  prompt: "I feel secure in my job (I will still have a job in a year from now)."
}, {
  prompt: "I am appropriately recognised for the work I do."
}, {
  prompt: "I am happy with the financial rewards for the work I do."
}, {
  prompt: "I feel burnt out because of my work."
}];
var questions = (0, _utils.wrapBattery)(workplaceQuestions, baseProps);
exports.questions = questions;

var normalize = function normalize(score) {
  return Math.round(100 * score / (agreeDisagree.length - 1));
};

function getResults(answers) {
  var humanReadable = {};
  questions.forEach(function (q, i) {
    humanReadable[q.prompt] = q.options[answers[i]];
  });
  return {
    wqSatisfiedWithJob: normalize(answers[0]),
    wqSecureInJob: normalize(answers[1]),
    wqRecognized: normalize(answers[2]),
    wqHappyWithFinancial: normalize(answers[3]),
    wqBurntOut: normalize(answers[4]),
    humanReadable: humanReadable
  };
}